import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Inner from "../../components/Inner";
import { routes } from "../../routes";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Inner>
      <div className="flex flex-col items-center justify-center py-12">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">
          {t("notFound.title", "Page Not Found")}
        </h2>
        <p className="text-gray-500 mb-6">
          {t("notFound.description", "Sorry, the page you are looking for does not exist or has been moved.")}
        </p>
        <Link
          to={routes.home}
          className="px-6 py-2 bg-black text-white rounded hover:bg-gray-800 transition"
        >
          {t("notFound.goHome", "Go back home")}
        </Link>
      </div>
    </Inner>
  );
};

export default NotFound;